import { render, staticRenderFns } from "./ContentArticleTags.vue?vue&type=template&id=d46a5892&"
import script from "./ContentArticleTags.vue?vue&type=script&lang=js&"
export * from "./ContentArticleTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports